export function clearLocalStorage() {
    localStorage.clear()
}